module.exports = __webpack_public_path__ + "static/media/PIBKG_purple.f72ad313.png";